import { Component, OnInit, isDevMode } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { User, UserAddress, SubstPolicy, PickUpCenter } from '../../_models';
import { UserService, UtilsService } from '../../_services';
import { HeaderService } from '../../_services/header.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { UserValidator } from 'src/app/_validators/user.validator';
import { ZipCodeValidator } from 'src/app/_validators/zipcode.validator';
import { DatePipe } from '@angular/common';
import { DocumentIDValidator } from 'src/app/_validators/document.validator';
import {DatesValidator} from 'src/app/_validators/dates.validator';

declare const $ : any;

@Component({
  selector: 'app-newuser',
  templateUrl: './newuser.component.html',
  styleUrls: ['./newuser.component.css']
})

export class NewuserComponent implements OnInit    {
  public step: number ;
  public submitted : boolean;
  public pickUpCenter : boolean;
  
  public useCard : boolean;
  public requestCard : boolean;
  public validCard :boolean;

  public usingApp : boolean;
  public requestApp : boolean;
  public omitApp :boolean;

  public billingAddress :boolean;
  public newUserForm1: FormGroup;
  public newUserForm2: FormGroup;
  public newUserForm3: FormGroup;

  
  public user : User;

  public get currentStep() : number { return this.step; }


  public substPolicies : SubstPolicy[];
  public pickUpCenters : PickUpCenter[];

  constructor(
      private header : HeaderService,
      private users : UserService,
      private formBuilder: FormBuilder,
      private toastr: ToastrService,
      private translate: TranslateService,
      private userValidator: UserValidator,
      private zipCodeValidator: ZipCodeValidator,
      private utils: UtilsService,
      private datePipe: DatePipe
      
      ) {
        this.header.setHeader(false,false,false,false);
        this.utils.getSubstPolicies(this.translate.currentLang).subscribe(subsPolicies => this.substPolicies = subsPolicies );
      }

      
  // convenience getter for easy access to form fields
  get f1() { 
    return this.newUserForm1.controls; 
  }
  get f2() { 
    return this.newUserForm2.controls; 
  }
  get f3() { 
    return this.newUserForm3.controls; 
  }

  checkPasswords(group: FormGroup) {
    let pass = group.controls.password.value;
    let confirmPass = group.controls.verifyPassword.value;

    return pass === confirmPass ? null : { notSamePassword: true }     
  }

  checkEmails(group: FormGroup) {
    let email = group.controls.email.value;
    let confirmEamil = group.controls.verifyEmail.value;

    return email === confirmEamil ? null : { notSameEmail: true }     
  }

  ngOnInit() {
    
    this.submitted = false;
    this.step = 1;
    this.pickUpCenter = false;
    this.useCard = false;
    this.requestCard = false;
    this.validCard = false;
    this.requestCard =false;
    this.billingAddress = false;

    this.newUserForm1 = this.formBuilder.group({
      username: ['',  Validators.required, this.userValidator.checkUsername.bind(this.userValidator,null)], 
      password: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(10)]],
      email: ['', [Validators.required, Validators.email],  this.userValidator.checkEmail.bind(this.userValidator) ] ,
      verifyPassword: ['', [Validators.minLength(4), Validators.maxLength(10)]],
      verifyEmail: [''],
      rgpd: ['', Validators.requiredTrue],
      publi: [''],
    }, {validator: [this.checkPasswords, this.checkEmails] });

    this.newUserForm2 = this.formBuilder.group({
      name: ['',  Validators.required],
      surnames: ['',  Validators.required],
      birthDateDay : [''],
      birthDateMonth : [''],
      birthDateYear : [''],
      dni: ['',  [Validators.required, DocumentIDValidator.validateDocumentId ]],
      street: ['',  Validators.required],
      number: ['',  Validators.required],
      floor: [''],
      door: [''],
      stair: [''],
      zipCode: ['',  Validators.required, this.zipCodeValidator.checkZipCode.bind(this.zipCodeValidator ) ],
      city: ['',  Validators.required],
      province: ['', Validators.required],
      //20250602 axa inici
      factura_electronica: [true],
      //20250602 axa final

      billingStreet: [''],
      billingNumber: [''],
      billingFloor: [''],
      billingDoor: [''],
      billingStair: [''],
      billingZipCode: [''],
      billingCity: [''],
      billingProvince: [''],

      phone1: ['',  [Validators.required, Validators.minLength(8), Validators.maxLength(16) ]] ,
      phone2: ['',  [Validators.minLength(8), Validators.maxLength(16) ]],
      substPolicy: ['',  Validators.required],
      pickUpCenter : [''],
      billing: [! this.billingAddress],
      cardPhone :[''],
      card: [''],
      cardBirthDateDay : [''] ,
      cardBirthDateMonth : [''],
      cardBirthDateYear : [''],
      app: ['']
    },{validator: DatesValidator.validDayInMonth});

    this.newUserForm3 = this.formBuilder.group({
      app: ['']
    });

    this.user = new User();
    this.utils.getClientIp().subscribe( ip =>{
      this.user.user_agent = window.navigator.userAgent + ` [[${ip.ip}]]`;
    });

    // TEST
    // if (isDevMode){
    //   this.step = 4; 
    //   this.user.get_plusi_card = 2;
    // }

  }

  setZipCode (){

    this.utils.getProvince(this.f2.zipCode.value).subscribe(province => this.f2.province.setValue(province))
    this.utils.getPickUpCenter(this.f2.zipCode.value).subscribe( 
      pickUpCenter => {

      if (parseInt(pickUpCenter) == 0) {
          this.pickUpCenter = true;
          this.newUserForm2.addControl('pickUpCenter', new FormControl('', Validators.required));
          this.utils.getPickUpCenters().subscribe(pickupCenters => this.pickUpCenters = pickupCenters);
        } else{
          this.pickUpCenter = false;
          this.newUserForm2.removeControl('pickUpCenter');
        }
      },
      error => {
        this.pickUpCenter = true;
        this.newUserForm2.addControl('pickUpCenter', new FormControl('', Validators.required));
        this.utils.getPickUpCenters().subscribe(pickupCenters => this.pickUpCenters = pickupCenters);
      } 
    );

  }


  setBillingZipCode (){
    this.utils.getProvince(this.f2.billingZipCode.value).subscribe(province => this.f2.billingProvince.setValue(province));
  }

  setCard(value: string){

    switch(value) {
        case 'use':
          this.useCard = true;
          this.newUserForm2.addControl('cardPhone', new FormControl('', Validators.required));
          this.requestCard = false;
          this.f2.app.disable();
          break;
        case 'request': 
          this.useCard = false;
          this.requestCard = true;
          this.newUserForm2.removeControl('cardPhone');
          this.f2.app.disable();
          this.f2.app.setValue(null);
          this.usingApp=false;
          this.validCard=false;
          break;
        case 'no': 
          this.useCard = false;
          this.requestCard = false;
          this.newUserForm2.removeControl('cardPhone');
          this.f2.app.disable();
          this.f2.app.setValue(null);
          this.usingApp=false;
          this.validCard=false;
          break;
      };

  }

  setApp(value: string){

    switch(value) {

        case 'using':
          this.usingApp=true;
          break;
        case 'request': 
          this.usingApp=true;
          break;
        case 'no': 
          this.usingApp=false;
          break;
      };

  }



  validateCard() : any{   
    return this.utils.validatePlusiCard(
          this.f2.cardPhone.value, 
          this.datePipe.transform( new Date(this.f2.cardBirthDateYear.value,this.f2.cardBirthDateMonth.value - 1, this.f2.cardBirthDateDay.value), 'dd/MM/yyyy'))
      .subscribe(
        id_plusi_card => {
          this.user.id_plusi_card = id_plusi_card;
          this.validCard = id_plusi_card != null;
          this.f2.app.enable();
        },
        error => {
          this.validCard = false;
          this.user.id_plusi_card = '';
        }
      );
  }
  
  onSubmitStep(step : number){
    this.submitted = true;

    switch (step)
    {
      
      case 1 : {
        if (this.newUserForm1.invalid) {
          this.header.scrollTop();
          return;
        }

        this.user.language = this.translate.currentLang;
        this.user.id_user = this.f1.username.value;        
        this.user.password = this.f1.password.value;
        this.user.email = this.f1.email.value;
        this.user.publi = this.f1.publi.value ? 1 : 0;
        this.user.rgpd = this.f1.rgpd.value ? 1: 0;

        this.submitted = false;
        this.step = step + 1;
        this.header.scrollTop();

        break;
      }
      case 2 : {

        if (this.useCard){
          this.validateCard();
        }

        if (this.newUserForm2.invalid || ( this.useCard && ! this.validCard) ) {
          this.header.scrollTop();
          return;
        }

        let address: UserAddress = new UserAddress();       
        let bAddress : UserAddress = new UserAddress();

        this.user.name = this.f2.name.value;
        this.user.surname1 = this.f2.surnames.value;
        this.user.dni = this.f2.dni.value;
        this.user.birth_date = this.datePipe.transform( new Date(this.f2.birthDateYear.value,this.f2.birthDateMonth.value -1, this.f2.birthDateDay.value), 'dd/MM/yyyy');
        this.user.phone1 = this.f2.phone1.value;
        this.user.phone2 = this.f2.phone2.value;
        this.user.subst_policy = this.f2.substPolicy.value;

        address.address_type = 2;
        address.address_name = 'Principal';
        address.address_street = this.f2.street.value;
        address.address_number =this.f2.number.value;
        address.address_floor = this.f2.floor.value;
        address.address_door = this.f2.door.value;
        address.address_stair = this.f2.stair.value;
        address.zipcode = this.f2.zipCode.value;
        address.city = this.f2.city.value;
        address.province = this.f2.province.value;      

        if (this.pickUpCenter) {
          //Hacer obligatorio el pickupcenter
          if (this.f2.pickUpCenter.value==""){
            this.header.scrollTop();
            this.submitted=false;
            return;
          }
          
          address.centre_ClickRecull = this.f2.pickUpCenter.value ;
          //.user.user_addresses[0].centre_ClickRecull

        }
        
        address.isprimary = 1;
        address.recid ='';
        address.observ = '';

        this.user.user_addresses.splice(0,this.user.user_addresses.length);

        if (this.billingAddress) {
          bAddress.address_type = 1;
          bAddress.address_name = 'Factura';
          bAddress.address_street = this.f2.billingStreet.value;
          bAddress.address_number = this.f2.billingNumber.value;
          bAddress.address_floor = this.f2.billingFloor.value;
          bAddress.address_door = this.f2.billingDoor.value;
          bAddress.address_stair = this.f2.billingStair.value;
          bAddress.zipcode = this.f2.billingZipCode.value;
          bAddress.city = this.f2.billingCity.value;
          bAddress.province = this.f2.billingProvince.value;
          bAddress.isprimary = 0;
        } else {        

          bAddress.address_type = 1;
          bAddress.address_name = 'Factura';
          bAddress.address_street = address.address_street;
          bAddress.address_number = address.address_number;
          bAddress.address_floor = address.address_floor;
          bAddress.address_door = address.address_door;
          bAddress.address_stair = address.address_stair;
          bAddress.zipcode = address.zipcode;
          bAddress.city = address.city;
          bAddress.province = address.province;
          bAddress.isprimary = 0;
        }

        this.user.user_addresses.push(address);  
        this.user.user_addresses.push(bAddress);
               
        if (this.useCard){
          this.user.get_plusi_card = 0;
          // this.user.id_plusi_card = '';
          this.user.phone_plusi_card = this.f2.cardPhone.value;
          this.user.birth_plusi_card = this.datePipe.transform(new Date(this.f2.cardBirthDateYear.value,this.f2.cardBirthDateMonth.value -1, this.f2.cardBirthDateDay.value),'dd/MM/yyyy');
        }
        else if (this.requestCard){
          this.user.get_plusi_card = 1;
          this.user.id_plusi_card = '';
          this.user.phone_plusi_card = '';
          this.user.birth_plusi_card = '';
        } else {
          this.user.get_plusi_card = 2;
          this.user.id_plusi_card = '';
          this.user.phone_plusi_card = '';
          this.user.birth_plusi_card = '';
        }
        
        this.step = step + 1;
        this.submitted = false; 
        this.header.scrollTop();
        break;
      }
      case 3 : {


        return this.users.create(this.user).subscribe(
          result => {
            this.step += 1;
            this.header.scrollTop();
          },
          error =>{
            this.submitted = false;
          }
        );       
      }
    }

  }

  goBack(){
    this.step = this.step -1;
    this.header.scrollTop();
  }

  onRGPD(){
    $('#modal-registre-rgpd').modal('show');
    return false;
  }
 
  setBillingAddress(){

    this.billingAddress = !this.billingAddress;

    if (this.billingAddress) {
      this.newUserForm2.controls['billingStreet'].setValidators([Validators.required, Validators.maxLength(128)]);
      this.newUserForm2.controls['billingNumber'].setValidators([Validators.required,Validators.maxLength(128)]);
      this.newUserForm2.controls['billingFloor'].setValidators([Validators.maxLength(4)]);
      this.newUserForm2.controls['billingDoor'].setValidators([Validators.maxLength(4)]);
      this.newUserForm2.controls['billingStair'].setValidators([Validators.maxLength(4)]);
      this.newUserForm2.controls['billingZipCode'].setValidators([Validators.required, Validators.maxLength(8)]);
      this.newUserForm2.controls['billingCity'].setValidators([Validators.required, Validators.maxLength(60)]);
    } else {
      this.newUserForm2.controls['billingStreet'].setValidators(null);
      this.newUserForm2.controls['billingNumber'].setValidators(null);
      this.newUserForm2.controls['billingFloor'].setValidators(null);
      this.newUserForm2.controls['billingDoor'].setValidators(null);
      this.newUserForm2.controls['billingStair'].setValidators(null);
      this.newUserForm2.controls['billingZipCode'].setValidators(null);
      this.newUserForm2.controls['billingCity'].setValidators(null);
    }

  }

  //20250602 axa inici
  setSendBill() {
    this.f2.factura_electronica.value ? this.user.factura_electronica = 1 : this.user.factura_electronica = 0;
    console.log(`F2: ${this.f2.factura_electronica.value}`);
    console.log(`USER: ${this.user.factura_electronica}`);
  }
  //20250602 axa final

}
